import React from 'react'
import PropTypes from 'prop-types'
import { getCurrentLangKey, getLangs, getUrlForLang } from 'ptz-i18n'
import { IntlProvider } from 'react-intl'
import 'intl'

//Components
import Header from '../components/Header'
import Footer from '../components/Footer'

//Files
import '../styles/index.scss'

const TemplateWrapper = ({ children, data, location, i18nMessages }) => {
  const url = location.pathname
  const { langs, defaultLangKey } = data.site.siteMetadata.languages
  const langKey = getCurrentLangKey(langs, defaultLangKey, url)
  const homeLink = `/${langKey}/`
  const langsMenu = getLangs(langs, langKey, getUrlForLang(homeLink, url))

  return (
    <IntlProvider locale={langKey} messages={i18nMessages}>
      <React.Fragment>
        <Header langs={langsMenu} headerLogo={data.headerLogo} />
        <div className="main-content container">{children()}</div>
        <Footer langs={langsMenu} footerLogo={data.footerLogo} />
      </React.Fragment>
    </IntlProvider>
  )
}

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper

export const fleetDataFragmentQuery = graphql`
  fragment FleetData on DataJson {
    fleetTypes {
      value
      label {
        en
        es
      }
    }
    fleetFeatures {
      key
      value
      label {
        en
        es
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js